<template>
  <p>{{ state.test }}</p>
</template>

<script>
import { store } from '../state/store'
export default {
  props: {
    text: {
      type: String,
      default: 'Type in the input box to test changing state across components',
    },
  },
  data() {
    return {
      state: store.state,
    }
  },
}
</script>
